import script from "./CookieForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieForm.vue?vue&type=script&setup=true&lang=js"

import "./CookieForm.vue?vue&type=style&index=0&id=2d460c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d460c8e"]])

export default __exports__